/*=========================================================================================
	File Name: analyticsData.vue
	Description: Data shown by charts
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const themeColors = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']

const market = 'AED';

export default {
  appConf: {
      currency: market
  },

  // LINE CHART
  revenueComparisonLine: {
      series: [{
              name: "This Month",
              data: [65000, 67000, 68800, 67500, 68500, 68000, 66500, 71445]
          },
          {
              name: "Last Month",
              data: [56000, 58000, 55500, 56600, 54500, 56500, 55000, 58324]
          }
      ],
      chartOptions: {
          chart: {
              toolbar: { show: false },
          },
          stroke: {
              curve: 'smooth',
              dashArray: [0, 8],
              width: [4, 2],
          },
          grid: {
              borderColor: '#e7e7e7',
          },
          legend: {
              show: false,
          },
          colors: ['#F97794', '#b8c2cc'],
          fill: {
              type: 'gradient',
              gradient: {
                  shade: 'dark',
                  inverseColors: false,
                  gradientToColors: ['#7367F0', '#b8c2cc'],
                  shadeIntensity: 1,
                  type: 'horizontal',
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100, 100, 100]
              },
          },
          markers: {
              size: 0,
              hover: {
                  size: 5
              }
          },
          xaxis: {
              labels: {
                  style: {
                      cssClass: 'text-grey fill-current',
                  }
              },
              axisTicks: {
                  show: false,
              },
              categories: ['01', '05', '09', '13', '17', '21', '26', '31'],
              axisBorder: {
                  show: false,
              },
          },
          yaxis: {
              tickAmount: 5,
              labels: {
                  style: {
                      cssClass: 'text-grey fill-current',
                  },
                  formatter: function(val) {
                      return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                  }
              }
          },
          tooltip: {
              x: { show: false }
          }
      }
  },

  // RADIAL BAR
  goalOverviewRadialBar: {
      series: [97],
      chartOptions: {
          plotOptions: {
              radialBar: {
                  size: 110,
                  startAngle: -150,
                  endAngle: 150,
                  hollow: {
                      size: '77%',
                  },
                  track: {
                      background: "#bfc5cc",
                      strokeWidth: '50%',
                  },
                  dataLabels: {
                      name: {
                          show: false
                      },
                      value: {
                          offsetY: 18,
                          color: '#99a2ac',
                          fontSize: '4rem'
                      }
                  }
              }
          },
          colors: ['#00db89'],
          fill: {
              type: 'gradient',
              gradient: {
                  shade: 'dark',
                  type: 'horizontal',
                  shadeIntensity: 0.5,
                  gradientToColors: ['#00b5b5'],
                  inverseColors: true,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
              },
          },
          stroke: {
              lineCap: 'round'
          },
          chart: {
              sparkline: {
                  enabled: true,
              },
              dropShadow: {
                  enabled: true,
                  blur: 3,
                  left: 1,
                  top: 1,
                  opacity: 0.1
              },
          },
      }
  },

  // LINE AREA CHART
  subscribersGained: {
      series: [{
          name: 'Skus',
          data: [28, 40, 36, 52, 38, 60, 55]
      }],
      chartOptions: {
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0
              }
          },
          chart: {
              toolbar: {
                  show: false,
              },
              sparkline: {
                  enabled: true
              }
          },
          dataLabels: {
              enabled: false
          },
          stroke: {
              curve: 'smooth',
              width: 2.5
          },
          fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 0.9,
                  opacityFrom: 0.7,
                  opacityTo: 0.5,
                  stops: [0, 80, 100]
              }
          },
          xaxis: {
              type: 'numeric',
              lines: {
                  show: false,
              },
              axisBorder: {
                  show: false,
              },
              labels: { show: false }
          },
          yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
          }],
          tooltip: {
              x: { show: false }
          },
      },
  },
  quarterlySales: {
      series: [{
          name: 'Scanned',
          data: [10, 15, 7, 12, 3, 16]
      }],
      chartOptions: {
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0
              }
          },
          chart: {
              toolbar: {
                  show: false,
              },
              sparkline: {
                  enabled: true
              }
          },
          dataLabels: {
              enabled: false
          },
          stroke: {
              curve: 'smooth',
              width: 2.5
          },
          fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 0.9,
                  opacityFrom: 0.7,
                  opacityTo: 0.5,
                  stops: [0, 80, 100]
              }
          },
          xaxis: {
              type: 'numeric',
              lines: {
                  show: false,
              },
              axisBorder: {
                  show: false,
              },
              labels: { show: false }
          },
          yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
          }],
          tooltip: {
              x: { show: false }
          },
      },
  },
  revenueGenerated: {
      series: [{
          name: 'Competitors',
          data: [350, 275, 400, 300, 350, 300, 450]
      }],
      chartOptions: {
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0
              }
          },
          chart: {
              toolbar: {
                  show: false,
              },
              sparkline: {
                  enabled: true
              }
          },
          dataLabels: {
              enabled: false
          },
          stroke: {
              curve: 'smooth',
              width: 2.5
          },
          fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 0.9,
                  opacityFrom: 0.7,
                  opacityTo: 0.5,
                  stops: [0, 80, 100]
              }
          },
          xaxis: {
              type: 'numeric',
              lines: {
                  show: false,
              },
              axisBorder: {
                  show: false,
              },
              labels: { show: false }
          },
          yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
          }],
          tooltip: {
              x: { show: false }
          },
      },
  },
  ordersRecevied: {
      series: [{
          name: 'Competitiveness',
          data: [10, 15, 8, 15, 7, 12, 8]
      }],
      chartOptions: {
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0
              }
          },
          chart: {
              toolbar: {
                  show: false,
              },
              sparkline: {
                  enabled: true
              }
          },
          dataLabels: {
              enabled: false
          },
          stroke: {
              curve: 'smooth',
              width: 2.5
          },
          fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 0.9,
                  opacityFrom: 0.7,
                  opacityTo: 0.5,
                  stops: [0, 80, 100]
              }
          },
          xaxis: {
              type: 'numeric',
              lines: {
                  show: false,
              },
              axisBorder: {
                  show: false,
              },
              labels: { show: false }
          },
          yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
          }],
          tooltip: {
              x: { show: false }
          },
      },
  },

  //Competitors
  browserAnalytics: [{
          id: 1,
          name: 'Emaxme',
          ratio: 73,
          time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
          comparedResult: '800'
      },
      {
          id: 3,
          name: 'Lulu',
          ratio: 8,
          time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
          comparedResult: '-200'
      },
      {
          id: 2,
          name: 'Carrefouruae',
          ratio: 19,
          time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
          comparedResult: '100'
      },
      {
          id: 4,
          name: 'Erosgroup',
          ratio: 27,
          time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
          comparedResult: '-450'
      },
  ],

  // ClientRetention Bar Chart
  

  //Dummy for detail competition
  revenueComparisonLine1: {
      series: [{
              name: "Our Price",
              data: [256, 300, 288, 199, 212, 222, 200, 199]
          },
          {
              name: "Emaxme",
              data: [300, 288, 199, 212, 222, 200, 199, 399]
          },
          {
              name: "Lulu",
              data: [288, 199, 212, 222, 200, 199, 399, 300]
          },
          {
              name: "Carrefouruae",
              data: [199, 212, 222, 200, 199, 399, 300, 288]
          }
      ],
      chartOptions: {
          chart: {
              toolbar: { show: false },
          },
          stroke: {
              curve: 'smooth',
              dashArray: [0, 8],
              width: [4, 2],
          },
          grid: {
              borderColor: '#e7e7e7',
          },
          legend: {
              show: false,
          },
          colors: ['#F97794', '#b8c2cc'],
          fill: {
              type: 'gradient',
              gradient: {
                  shade: 'dark',
                  inverseColors: false,
                  gradientToColors: ['#7367F0', '#b8c2cc'],
                  shadeIntensity: 1,
                  type: 'horizontal',
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100, 100, 100]
              },
          },
          markers: {
              size: 0,
              hover: {
                  size: 5
              }
          },
          xaxis: {
              labels: {
                  style: {
                      cssClass: 'text-grey fill-current',
                  }
              },
              axisTicks: {
                  show: false,
              },
              categories: ['01', '05', '09', '13', '17', '21', '26', '31'],
              axisBorder: {
                  show: false,
              },
          },
          yaxis: {
              tickAmount: 5,
              labels: {
                  style: {
                      cssClass: 'text-grey fill-current',
                  },
                  formatter: function(val) {
                      return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                  }
              }
          },
          tooltip: {
              x: { show: false }
          }
      }
  },

  competitorData: {
      topCompeteStat : [{
              id: "10001",
              name: 'Lulu',
              ratio: 73,
              time: 'Sun Aug 11 2019 07:46:05 GMT+0000 (GMT)',
              comparativeScore: '800'
          },
          {
              id: "10004",
              name: 'Emaxme',
              ratio: 8,
              time: 'Sun Aug 11 2019 05:22:05 GMT+0000 (GMT)',
              comparativeScore: '-200'
          },
          {
              id: "10002",
              name: 'Carrefouruae',
              ratio: 19,
              time: 'Sat Apr 13 2019 09:23:05 GMT+0000 (GMT)',
              comparativeScore: '100'
          },
          {
              id: "10003",
              name: 'Erosgroup',
              ratio: 27,
              time: 'Mon Dec 10 2018 04:12:05 GMT+0000 (GMT)',
              comparativeScore: '-450'
          },
      ],
      competeRetention: {
          series: [{
              name: 'Our Price',
              data: [175, 125, 225, 175, 160, 189, 100, 400, 159, 216, 148, 123]
          }, {
              name: 'Competitors',
              data: [-144, -155, -141, -167, -122, -143, -158, -107, -126, -131, -140, -137]
          }],
          chartOptions: {
              grid: {
                  borderColor: '#ebebeb',
                  padding: {
                      left: 0,
                      right: 0
                  }
              },
              legend: {
                  show: false,
              },
              dataLabels: {
                  enabled: false
              },
              chart: {
                  stacked: true,
                  type: 'bar',
                  toolbar: { show: false },
              },
              colors: ['#7367F0', '#EA5455'],
              plotOptions: {
                  bar: {
                      columnWidth: '10%'
                  }
              },
              xaxis: {
                  labels: {
                      style: {
                          cssClass: 'text-grey fill-current',
                      }
                  },
                  axisTicks: {
                      show: false,
                  },
                  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                  axisBorder: {
                      show: false,
                  },
              },
              yaxis: {
                  tickAmount: 5,
                  labels: {
                      style: {
                          cssClass: 'text-grey fill-current',
                      }
                  }
              },
              tooltip: {
                  x: { show: false }
              },
          }
      },
      overview: [{
          "id": "10001",
          "brand": "Lulu",
          "market": "UAE",
          "skuMatch": "250",
          "similarity": "50",
          "competeLevel": "High",
          "lookup": "Every Day",
          "status": "Paused"
      },
      {
          "id": "10002",
          "brand": "Emaxme",
          "market": "UAE",
          "skuMatch": "125",
          "similarity": "25",
          "competeLevel": "Medium",
          "lookup": "Every 2 Days",
          "status": "Paused"
      },
      {
          "id": "10003",
          "brand": "Carrefouruae",
          "market": "UAE",
          "skuMatch": "375",
          "similarity": "75",
          "competeLevel": "High",
          "lookup": "Every Week",
          "status": "Active"
      },
      {
          "id": "10004",
          "brand": "Erosgroup",
          "market": "UAE",
          "skuMatch": "60",
          "similarity": "15",
          "competeLevel": "Low",
          "lookup": "Every Day",
          "status": "Active"
      }

  ]
},

  mixedChart: {
    series: [{
            name: 'Sale',
            type: 'column',
            data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
        }, {
            name: 'In Stock',
            type: 'area',
            data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
        }, {
            name: 'Forecast',
            type: 'line',
            data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
    }],
    chartOptions: {
        colors: themeColors,
        chart: {
            stacked: false,
        },
        stroke: {
            width: [0, 2, 5],
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },

        fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['01/01/2018', '02/01/2018', '03/01/2018', '04/01/2018', '05/01/2018', '06/01/2018', '07/01/2018',
            '08/01/2018', '09/01/2018', '10/01/2018', '11/01/2018'
        ],
        markers: {
            size: 0
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            title: {
                text: 'Value ( k '+market+' )',
            },
            min: 0
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function(y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + " k "+market;
                    }
                    return y;

                }
            }
        }
    }
  },
    // BAR CHART
    salesBar: {
      series: [{
          name: 'Competitve Skus',
          data: [0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 100, 0, 0, 0, 0, 100, 0, 0, 0, 0, 100, 0, 0, 0]
      }],
      chartOptions: {
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0
              }
          },
          chart: {
              type: 'bar',
              sparkline: { enabled: true },
              toolbar: { show: false },
          },
          states: {
              hover: {
                  filter: 'none'
              }
          },
          colors: ['#7367f0'],
          plotOptions: {
              bar: {
                  // horizontal: true,
                  columnWidth: '45%',
                  distributed: true,
                  // endingShape: 'rounded', // Deprecated
                  // borderRadius: '20px', // Coming Soon
              }
          },
          tooltip: {
              x: { show: true }
          },
      }
  },
  supportTrackerRadialBar: {
    chartData: {
        totalTickets: 163,
        openTickets: 103,
        lastResponse: '1d',
    },
    series: [97],
    chartOptions: {
        plotOptions: {
            radialBar: {
                size: 150,
                startAngle: -150,
                endAngle: 150,
                hollow: {
                    size: '65%',
                },
                track: {
                    background: "#fff",
                    strokeWidth: '100%',

                },
                dataLabels: {
                    value: {
                        offsetY: 30,
                        color: '#99a2ac',
                        fontSize: '2rem'
                    }
                }
            },
        },
        colors: ['#EA5455'],
        fill: {
            type: 'gradient',
            gradient: {
                // enabled: true,
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#7367F0'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            },
        },
        stroke: {
            dashArray: 8
        },
        chart: {
            sparkline: {
            }
        },
        labels: ['Completed Skus'],
    }
},

  stockData: [
      { id: 1, code: '1095946', name: 'Samsung Galaxy Note9', description: '128GB Midnight Black 4G LTE Dual Sim Smartphone SM-N960FZKDXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/04/95856878cc3b39c020225c4125fba75d7863d925_Image._Product_Key_Visual_Crown_Product_Image_Midnight_Black_180529_sm_n960f_galaxynote9_front_-300x300.jpg' ,rating: '4', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 100, status: 'delivered', efficiency: 70, inHand: 10, inTransit: 50, forecast: 120, diff: 110, stockOut: '30 Apr 2019'}, competition: { price: 3633, pos:  'down', source:  [{name: 'Emaxme', price: 3799, pos: 'down'}, {name: 'Lulu', price: 3599, pos: 'up'}, {name: 'Carrefouruae', price: 3500, pos: 'up'}]}},
      { id: 1, code: '1048173', name: 'Samsung Galaxy S9 Plus 256GB', description: 'Sunrise Gold 4G Dual Sim Smartphone - S9+ - SM-G965FZDHXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/ecd80824f972ae933ff403d13f36e296514fd73f_gs9_plus_gold_render_3-300x300.jpg' ,rating: '4', price:2049, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 20, status: 'on hold', efficiency: 34, inHand: 0, inTransit: 20, forecast: 50, diff: 50, stockOut: '29 Apr 2019'}, competition: { price: 2599, pos:  'down', source:  [{name: 'Emaxme', price: 2699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2699, pos: 'up'}, {name: 'Carrefouruae', price: 2599, pos: 'up'}]}},
      { id: 1, code: '1000086008', name: 'Apple iPhone 8 64GB', description: 'iPhone 8 64GB (Product) Red Special Edition - MRRM2AE/A', category: 'Mobile', brand: 'Apple', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/07/aea251c23c0fac5abd61daa11a8e116667da27d8_772d4c5d470cad1d504bd6eb45ec25096a9bf1df_iphone_8_red_2-300x300.jpeg' ,rating: '5', price:1999.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 50, status: 'delivered', efficiency: 56, inHand: 40, inTransit: 30, forecast: 40, diff: 30, stockOut: '30 May 2019'}, competition: { price: 1533, pos:  'up', source:  [{name: 'Emaxme', price: 1699, pos: 'down'}, {name: 'Lulu', price: 1399, pos: 'up'}, {name: 'Carrefouruae', price: 1400, pos: 'up'}]}},
      { id: 1, code: '1000084003', name: 'Apple iPhone 7', description: 'iPhone 7 32GB Silver - MN8Y2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/5735c47bce5d3acf4e62df385630aa9c75549a39_99cc2e41e085d812d337bcf5dbab93c079c1e3b2_2016_09_18_09_52_36_873_60706_optimized-14-145x300.jpg' ,rating: '4', price:1599, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 2333, pos:  'down', source:  [{name: 'Emaxme', price: 2200.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2200, pos: 'up'}, {name: 'Carrefouruae', price: 2600, pos: 'up'}]}},
      { id: 1, code: '1093164', name: 'Samsung Galaxy A30 64GB', description: 'Galaxy A30 64GB Blue 4G Dual Sim Smartphone SM-A305F - SM-A305FZBFXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/03/903470815dcfe639162daba0ff7e7ac53e8694e2_BL1-300x300.jpg' ,rating: '4', price:849.00, orderInfo: { lastOrderDate: 'Apr 23 2019', qty: 150, status: 'delivered', efficiency: 100, inHand: 10, inTransit: 150, forecast: 200, diff: 190, stockOut: '01 May 2019'}, competition: { price: 1199, pos:  'down', source:  [{name: 'Emaxme', price: 1099, pos: 'down'}, {name: 'Lulu', price: 1299, pos: 'up'}, {name: 'Carrefouruae', price: 1199, pos: 'up'}]}},
      { id: 1, code: '1000089003', name: 'Apple iPhone X', description: 'Apple iPhone X 256GB Silver - MQAG2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/3fc1e7ac0a6692cdab6cf302882e8f0e817087a3_492cb70b0e76729f95ad49264d04053992c942bd_sharaf_dg_online_best_price_iphone_x_silver-300x300.jpg' ,rating: '4', price:3699, orderInfo: { lastOrderDate: 'Apr 21 2019', qty: 20, status: 'on hold', efficiency: 44, inHand: 40, inTransit: 20, forecast: 50, diff: 10, stockOut: '01 May 2019'}, competition: { price: 4832, pos:  'down', source:  [{name: 'Emaxme', price: 4999.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 4699, pos: 'up'}, {name: 'Carrefouruae', price: 4799, pos: 'up'}]}},
      { id: 1, code: '1064111002', name: 'Apple iPhone XR', description: 'Apple iPhone XR 256GB Black - MRYJ2AE/A', category: 'Brownie', brand: 'Classic Brownies', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/10/492b0a18b39d8ad7732140b94065f58ddb0d9ba4_Black__1_1-300x300.jpg' ,rating: '5', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 10, status: 'delivered', efficiency: 90, inHand: 40, inTransit: 30, forecast: 50, diff: 40, stockOut: '01 May 2019'}, competition: { price: 2533, pos:  'down', source:  [{name: 'Emaxme', price: 2699, pos: 'down'}, {name: 'Lulu', price: 2399, pos: 'up'}, {name: 'Carrefouruae', price: 2400, pos: 'up'}]}},
      { id: 1, code: '1071332003', name: 'Samsung Galaxy A9 (2018)', description: 'Galaxy A9 (2018) 128GB Bubblegum Pink 4G Dual Sim Smartphone SMA920F - SM-A920FZIDXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/11/f9d11386e967eca9e9ab040aaf28fb04c91bd1aa_ae_galaxy_a9_a920_sm_a920fzidxsg_frontpink_121149303-300x300.jpg' ,rating: '4', price:1499, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 1666, pos:  'down', source:  [{name: 'Emaxme', price: 1699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 1599, pos: 'up'}, {name: 'Carrefouruae', price: 1700, pos: 'up'}]}},      
      { id: 1, code: '1095946', name: 'Samsung Galaxy Note9', description: '128GB Midnight Black 4G LTE Dual Sim Smartphone SM-N960FZKDXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/04/95856878cc3b39c020225c4125fba75d7863d925_Image._Product_Key_Visual_Crown_Product_Image_Midnight_Black_180529_sm_n960f_galaxynote9_front_-300x300.jpg' ,rating: '4', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 100, status: 'delivered', efficiency: 70, inHand: 10, inTransit: 50, forecast: 120, diff: 110, stockOut: '30 Apr 2019'}, competition: { price: 3633, pos:  'down', source:  [{name: 'Emaxme', price: 3799, pos: 'down'}, {name: 'Lulu', price: 3599, pos: 'up'}, {name: 'Carrefouruae', price: 3500, pos: 'up'}]}},
      { id: 1, code: '1048173', name: 'Samsung Galaxy S9 Plus 256GB', description: 'Sunrise Gold 4G Dual Sim Smartphone - S9+ - SM-G965FZDHXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/ecd80824f972ae933ff403d13f36e296514fd73f_gs9_plus_gold_render_3-300x300.jpg' ,rating: '4', price:2049, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 20, status: 'on hold', efficiency: 34, inHand: 0, inTransit: 20, forecast: 50, diff: 50, stockOut: '29 Apr 2019'}, competition: { price: 2599, pos:  'down', source:  [{name: 'Emaxme', price: 2699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2699, pos: 'up'}, {name: 'Carrefouruae', price: 2599, pos: 'up'}]}},
      { id: 1, code: '1000086008', name: 'Apple iPhone 8 64GB', description: 'iPhone 8 64GB (Product) Red Special Edition - MRRM2AE/A', category: 'Mobile', brand: 'Apple', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/07/aea251c23c0fac5abd61daa11a8e116667da27d8_772d4c5d470cad1d504bd6eb45ec25096a9bf1df_iphone_8_red_2-300x300.jpeg' ,rating: '5', price:1999.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 50, status: 'delivered', efficiency: 56, inHand: 40, inTransit: 30, forecast: 40, diff: 30, stockOut: '30 May 2019'}, competition: { price: 1533, pos:  'up', source:  [{name: 'Emaxme', price: 1699, pos: 'down'}, {name: 'Lulu', price: 1399, pos: 'up'}, {name: 'Carrefouruae', price: 1400, pos: 'up'}]}},
      { id: 1, code: '1000084003', name: 'Apple iPhone 7', description: 'iPhone 7 32GB Silver - MN8Y2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/5735c47bce5d3acf4e62df385630aa9c75549a39_99cc2e41e085d812d337bcf5dbab93c079c1e3b2_2016_09_18_09_52_36_873_60706_optimized-14-145x300.jpg' ,rating: '4', price:1599, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 2333, pos:  'down', source:  [{name: 'Emaxme', price: 2200.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2200, pos: 'up'}, {name: 'Carrefouruae', price: 2600, pos: 'up'}]}},
      { id: 1, code: '1093164', name: 'Samsung Galaxy A30 64GB', description: 'Galaxy A30 64GB Blue 4G Dual Sim Smartphone SM-A305F - SM-A305FZBFXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/03/903470815dcfe639162daba0ff7e7ac53e8694e2_BL1-300x300.jpg' ,rating: '4', price:849.00, orderInfo: { lastOrderDate: 'Apr 23 2019', qty: 150, status: 'delivered', efficiency: 100, inHand: 10, inTransit: 150, forecast: 200, diff: 190, stockOut: '01 May 2019'}, competition: { price: 1199, pos:  'down', source:  [{name: 'Emaxme', price: 1099, pos: 'down'}, {name: 'Lulu', price: 1299, pos: 'up'}, {name: 'Carrefouruae', price: 1199, pos: 'up'}]}},
      { id: 1, code: '1000089003', name: 'Apple iPhone X', description: 'Apple iPhone X 256GB Silver - MQAG2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/3fc1e7ac0a6692cdab6cf302882e8f0e817087a3_492cb70b0e76729f95ad49264d04053992c942bd_sharaf_dg_online_best_price_iphone_x_silver-300x300.jpg' ,rating: '4', price:3699, orderInfo: { lastOrderDate: 'Apr 21 2019', qty: 20, status: 'on hold', efficiency: 44, inHand: 40, inTransit: 20, forecast: 50, diff: 10, stockOut: '01 May 2019'}, competition: { price: 4832, pos:  'down', source:  [{name: 'Emaxme', price: 4999.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 4699, pos: 'up'}, {name: 'Carrefouruae', price: 4799, pos: 'up'}]}},
      { id: 1, code: '1064111002', name: 'Apple iPhone XR', description: 'Apple iPhone XR 256GB Black - MRYJ2AE/A', category: 'Brownie', brand: 'Classic Brownies', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/10/492b0a18b39d8ad7732140b94065f58ddb0d9ba4_Black__1_1-300x300.jpg' ,rating: '5', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 10, status: 'delivered', efficiency: 90, inHand: 40, inTransit: 30, forecast: 50, diff: 40, stockOut: '01 May 2019'}, competition: { price: 2533, pos:  'down', source:  [{name: 'Emaxme', price: 2699, pos: 'down'}, {name: 'Lulu', price: 2399, pos: 'up'}, {name: 'Carrefouruae', price: 2400, pos: 'up'}]}},
      { id: 1, code: '1071332003', name: 'Samsung Galaxy A9 (2018)', description: 'Galaxy A9 (2018) 128GB Bubblegum Pink 4G Dual Sim Smartphone SMA920F - SM-A920FZIDXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/11/f9d11386e967eca9e9ab040aaf28fb04c91bd1aa_ae_galaxy_a9_a920_sm_a920fzidxsg_frontpink_121149303-300x300.jpg' ,rating: '4', price:1499, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 1666, pos:  'down', source:  [{name: 'Emaxme', price: 1699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 1599, pos: 'up'}, {name: 'Carrefouruae', price: 1700, pos: 'up'}]}},     
      { id: 1, code: '1095946', name: 'Samsung Galaxy Note9', description: '128GB Midnight Black 4G LTE Dual Sim Smartphone SM-N960FZKDXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/04/95856878cc3b39c020225c4125fba75d7863d925_Image._Product_Key_Visual_Crown_Product_Image_Midnight_Black_180529_sm_n960f_galaxynote9_front_-300x300.jpg' ,rating: '4', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 100, status: 'delivered', efficiency: 70, inHand: 10, inTransit: 50, forecast: 120, diff: 110, stockOut: '30 Apr 2019'}, competition: { price: 3633, pos:  'down', source:  [{name: 'Emaxme', price: 3799, pos: 'down'}, {name: 'Lulu', price: 3599, pos: 'up'}, {name: 'Carrefouruae', price: 3500, pos: 'up'}]}},
      { id: 1, code: '1048173', name: 'Samsung Galaxy S9 Plus 256GB', description: 'Sunrise Gold 4G Dual Sim Smartphone - S9+ - SM-G965FZDHXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/ecd80824f972ae933ff403d13f36e296514fd73f_gs9_plus_gold_render_3-300x300.jpg' ,rating: '4', price:2049, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 20, status: 'on hold', efficiency: 34, inHand: 0, inTransit: 20, forecast: 50, diff: 50, stockOut: '29 Apr 2019'}, competition: { price: 2599, pos:  'down', source:  [{name: 'Emaxme', price: 2699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2699, pos: 'up'}, {name: 'Carrefouruae', price: 2599, pos: 'up'}]}},
      { id: 1, code: '1000086008', name: 'Apple iPhone 8 64GB', description: 'iPhone 8 64GB (Product) Red Special Edition - MRRM2AE/A', category: 'Mobile', brand: 'Apple', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/07/aea251c23c0fac5abd61daa11a8e116667da27d8_772d4c5d470cad1d504bd6eb45ec25096a9bf1df_iphone_8_red_2-300x300.jpeg' ,rating: '5', price:1999.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 50, status: 'delivered', efficiency: 56, inHand: 40, inTransit: 30, forecast: 40, diff: 30, stockOut: '30 May 2019'}, competition: { price: 1533, pos:  'up', source:  [{name: 'Emaxme', price: 1699, pos: 'down'}, {name: 'Lulu', price: 1399, pos: 'up'}, {name: 'Carrefouruae', price: 1400, pos: 'up'}]}},
      { id: 1, code: '1000084003', name: 'Apple iPhone 7', description: 'iPhone 7 32GB Silver - MN8Y2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/5735c47bce5d3acf4e62df385630aa9c75549a39_99cc2e41e085d812d337bcf5dbab93c079c1e3b2_2016_09_18_09_52_36_873_60706_optimized-14-145x300.jpg' ,rating: '4', price:1599, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 2333, pos:  'down', source:  [{name: 'Emaxme', price: 2200.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2200, pos: 'up'}, {name: 'Carrefouruae', price: 2600, pos: 'up'}]}},
      { id: 1, code: '1093164', name: 'Samsung Galaxy A30 64GB', description: 'Galaxy A30 64GB Blue 4G Dual Sim Smartphone SM-A305F - SM-A305FZBFXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/03/903470815dcfe639162daba0ff7e7ac53e8694e2_BL1-300x300.jpg' ,rating: '4', price:849.00, orderInfo: { lastOrderDate: 'Apr 23 2019', qty: 150, status: 'delivered', efficiency: 100, inHand: 10, inTransit: 150, forecast: 200, diff: 190, stockOut: '01 May 2019'}, competition: { price: 1199, pos:  'down', source:  [{name: 'Emaxme', price: 1099, pos: 'down'}, {name: 'Lulu', price: 1299, pos: 'up'}, {name: 'Carrefouruae', price: 1199, pos: 'up'}]}},
      { id: 1, code: '1000089003', name: 'Apple iPhone X', description: 'Apple iPhone X 256GB Silver - MQAG2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/3fc1e7ac0a6692cdab6cf302882e8f0e817087a3_492cb70b0e76729f95ad49264d04053992c942bd_sharaf_dg_online_best_price_iphone_x_silver-300x300.jpg' ,rating: '4', price:3699, orderInfo: { lastOrderDate: 'Apr 21 2019', qty: 20, status: 'on hold', efficiency: 44, inHand: 40, inTransit: 20, forecast: 50, diff: 10, stockOut: '01 May 2019'}, competition: { price: 4832, pos:  'down', source:  [{name: 'Emaxme', price: 4999.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 4699, pos: 'up'}, {name: 'Carrefouruae', price: 4799, pos: 'up'}]}},
      { id: 1, code: '1064111002', name: 'Apple iPhone XR', description: 'Apple iPhone XR 256GB Black - MRYJ2AE/A', category: 'Brownie', brand: 'Classic Brownies', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/10/492b0a18b39d8ad7732140b94065f58ddb0d9ba4_Black__1_1-300x300.jpg' ,rating: '5', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 10, status: 'delivered', efficiency: 90, inHand: 40, inTransit: 30, forecast: 50, diff: 40, stockOut: '01 May 2019'}, competition: { price: 2533, pos:  'down', source:  [{name: 'Emaxme', price: 2699, pos: 'down'}, {name: 'Lulu', price: 2399, pos: 'up'}, {name: 'Carrefouruae', price: 2400, pos: 'up'}]}},
      { id: 1, code: '1071332003', name: 'Samsung Galaxy A9 (2018)', description: 'Galaxy A9 (2018) 128GB Bubblegum Pink 4G Dual Sim Smartphone SMA920F - SM-A920FZIDXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/11/f9d11386e967eca9e9ab040aaf28fb04c91bd1aa_ae_galaxy_a9_a920_sm_a920fzidxsg_frontpink_121149303-300x300.jpg' ,rating: '4', price:1499, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 1666, pos:  'down', source:  [{name: 'Emaxme', price: 1699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 1599, pos: 'up'}, {name: 'Carrefouruae', price: 1700, pos: 'up'}]}},
      { id: 1, code: '1095946', name: 'Samsung Galaxy Note9', description: '128GB Midnight Black 4G LTE Dual Sim Smartphone SM-N960FZKDXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/04/95856878cc3b39c020225c4125fba75d7863d925_Image._Product_Key_Visual_Crown_Product_Image_Midnight_Black_180529_sm_n960f_galaxynote9_front_-300x300.jpg' ,rating: '4', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 100, status: 'delivered', efficiency: 70, inHand: 10, inTransit: 50, forecast: 120, diff: 110, stockOut: '30 Apr 2019'}, competition: { price: 3633, pos:  'down', source:  [{name: 'Emaxme', price: 3799, pos: 'down'}, {name: 'Lulu', price: 3599, pos: 'up'}, {name: 'Carrefouruae', price: 3500, pos: 'up'}]}},
      { id: 1, code: '1048173', name: 'Samsung Galaxy S9 Plus 256GB', description: 'Sunrise Gold 4G Dual Sim Smartphone - S9+ - SM-G965FZDHXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/ecd80824f972ae933ff403d13f36e296514fd73f_gs9_plus_gold_render_3-300x300.jpg' ,rating: '4', price:2049, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 20, status: 'on hold', efficiency: 34, inHand: 0, inTransit: 20, forecast: 50, diff: 50, stockOut: '29 Apr 2019'}, competition: { price: 2599, pos:  'down', source:  [{name: 'Emaxme', price: 2699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2699, pos: 'up'}, {name: 'Carrefouruae', price: 2599, pos: 'up'}]}},
      { id: 1, code: '1000086008', name: 'Apple iPhone 8 64GB', description: 'iPhone 8 64GB (Product) Red Special Edition - MRRM2AE/A', category: 'Mobile', brand: 'Apple', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/07/aea251c23c0fac5abd61daa11a8e116667da27d8_772d4c5d470cad1d504bd6eb45ec25096a9bf1df_iphone_8_red_2-300x300.jpeg' ,rating: '5', price:1999.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 50, status: 'delivered', efficiency: 56, inHand: 40, inTransit: 30, forecast: 40, diff: 30, stockOut: '30 May 2019'}, competition: { price: 1533, pos:  'up', source:  [{name: 'Emaxme', price: 1699, pos: 'down'}, {name: 'Lulu', price: 1399, pos: 'up'}, {name: 'Carrefouruae', price: 1400, pos: 'up'}]}},
      { id: 1, code: '1000084003', name: 'Apple iPhone 7', description: 'iPhone 7 32GB Silver - MN8Y2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/5735c47bce5d3acf4e62df385630aa9c75549a39_99cc2e41e085d812d337bcf5dbab93c079c1e3b2_2016_09_18_09_52_36_873_60706_optimized-14-145x300.jpg' ,rating: '4', price:1599, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 2333, pos:  'down', source:  [{name: 'Emaxme', price: 2200.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 2200, pos: 'up'}, {name: 'Carrefouruae', price: 2600, pos: 'up'}]}},
      { id: 1, code: '1093164', name: 'Samsung Galaxy A30 64GB', description: 'Galaxy A30 64GB Blue 4G Dual Sim Smartphone SM-A305F - SM-A305FZBFXSG', category: 'Mobile', brand: 'Samsung', popularity: 97, image: 'https://s.sdgcdn.com/7/2019/03/903470815dcfe639162daba0ff7e7ac53e8694e2_BL1-300x300.jpg' ,rating: '4', price:849.00, orderInfo: { lastOrderDate: 'Apr 23 2019', qty: 150, status: 'delivered', efficiency: 100, inHand: 10, inTransit: 150, forecast: 200, diff: 190, stockOut: '01 May 2019'}, competition: { price: 1199, pos:  'down', source:  [{name: 'Emaxme', price: 1099, pos: 'down'}, {name: 'Lulu', price: 1299, pos: 'up'}, {name: 'Carrefouruae', price: 1199, pos: 'up'}]}},
      { id: 1, code: '1000089003', name: 'Apple iPhone X', description: 'Apple iPhone X 256GB Silver - MQAG2AE/A', category: 'Mobile', brand: 'Apple', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/07/3fc1e7ac0a6692cdab6cf302882e8f0e817087a3_492cb70b0e76729f95ad49264d04053992c942bd_sharaf_dg_online_best_price_iphone_x_silver-300x300.jpg' ,rating: '4', price:3699, orderInfo: { lastOrderDate: 'Apr 21 2019', qty: 20, status: 'on hold', efficiency: 44, inHand: 40, inTransit: 20, forecast: 50, diff: 10, stockOut: '01 May 2019'}, competition: { price: 4832, pos:  'down', source:  [{name: 'Emaxme', price: 4999.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 4699, pos: 'up'}, {name: 'Carrefouruae', price: 4799, pos: 'up'}]}},
      { id: 1, code: '1064111002', name: 'Apple iPhone XR', description: 'Apple iPhone XR 256GB Black - MRYJ2AE/A', category: 'Brownie', brand: 'Classic Brownies', popularity: 69, image: 'https://s.sdgcdn.com/7/2018/10/492b0a18b39d8ad7732140b94065f58ddb0d9ba4_Black__1_1-300x300.jpg' ,rating: '5', price:2399.00, orderInfo: { lastOrderDate: 'Apr 27 2019', qty: 10, status: 'delivered', efficiency: 90, inHand: 40, inTransit: 30, forecast: 50, diff: 40, stockOut: '01 May 2019'}, competition: { price: 2533, pos:  'down', source:  [{name: 'Emaxme', price: 2699, pos: 'down'}, {name: 'Lulu', price: 2399, pos: 'up'}, {name: 'Carrefouruae', price: 2400, pos: 'up'}]}},
      { id: 1, code: '1071332003', name: 'Samsung Galaxy A9 (2018)', description: 'Galaxy A9 (2018) 128GB Bubblegum Pink 4G Dual Sim Smartphone SMA920F - SM-A920FZIDXSG', category: 'Mobile', brand: 'Samsung', popularity: 83, image: 'https://s.sdgcdn.com/7/2018/11/f9d11386e967eca9e9ab040aaf28fb04c91bd1aa_ae_galaxy_a9_a920_sm_a920fzidxsg_frontpink_121149303-300x300.jpg' ,rating: '4', price:1499, orderInfo: { lastOrderDate: 'Mar 13 2019', qty: 199, status: 'on hold', efficiency: 89, inHand: 10, inTransit: 79, forecast: 120, diff: 110, stockOut: '01 May 2019'}, competition: { price: 1666, pos:  'down', source:  [{name: 'Emaxme', price: 1699.00, orderStatus: 'on hold', pos: 'down'}, {name: 'Lulu', price: 1599, pos: 'up'}, {name: 'Carrefouruae', price: 1700, pos: 'up'}]}},

    ],

  // Demo Routes Data

  // LINE CHART
  revenueComparisonLineDemo: {
    series: [{
      name: "Actual",
      data: [34192345, 36034234, 34556768, 37003454, 34323123]//, 1261, 1149, 1283, 1019, 1064, 1054, 1014]
    },
    {
      name: "Forecast",
      data: [35192345, 36434234, 34856768, 37103454, 35223123, 38023435] //, 1019, 1064, 1054, 1014, 1115, 1103, 1209, 1020, 1196]
    }
    ],
    chartOptions: {
      
      chart: {
        toolbar: { show: false },
      },
      stroke: {
        curve: 'smooth',
        dashArray: [0, 8],
        width: [4, 2],
      },
      grid: {
        borderColor: '#e7e7e7',
      },
      legend: {
        show: false,
      },
      colors: ['#F97794', '#b8c2cc'],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          inverseColors: false,
          gradientToColors: ['#7367F0', '#b8c2cc'],
          shadeIntensity: 1,
          type: 'horizontal',
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100]
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5
        }
      },
      xaxis: {
        labels: {
          style: {
            cssClass: 'text-grey fill-current',
          }
        },
        axisTicks: {
          show: false,
        },
        // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
        // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
        categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        tickAmount: 5,
        labels: {
          style: {
            cssClass: 'text-grey fill-current',
          },
          formatter: function (val) {
            return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
          }
        }
      },
      tooltip: {
        shared: true,
        intersect: false,
        // x: { show: false }
      }
    }
  },
  mixedChartDemo: {
   series: [{
      name: 'Rate of Sale per Week',
      type: 'column',
      categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
      data: [573, 490, 551, 495, 781, 385, 591, 862, 305, 129, 572, 708, 543, 146, 928, 905, 972, 958, 285, 234, 631, 534, 640, 568, 843, 453, 638, 921, 342, 137, 653, 776, 605, 204, 1005, 986, 981, 1019]
    }, {
      name: 'Stock In Hand',
      type: 'area',
      categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
      data: [157, 973, 248, 827, 577, 926, 884, 854, 658, 407, 746, 198, 804, 426, 115, 217, 185, 902, 715, 289, 251, 982, 322, 874, 656, 944, 973, 904, 734, 507, 789, 274, 837, 461, 208, 219, 233, 986]
    }, {
      name: 'Stock Insight',
      type: 'line',
      categories: ['Under Stock', 'Optimum Stock', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'Under Stock', 'Under Stock', 'Over Stock', 'Under Stock', 'Under Stock', 'Under Stock', 'OOS', 'Over Stock', 'OOS', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'Under Stock', 'Under Stock', 'Over Stock', 'Under Stock', 'Under Stock', 'Under Stock', 'OOS'],
      data: [157, 973, 248, 827, 577, 926, 884, 854, 658, 407, 746, 198, 804, 426, 115, 217, 185, 902, 715, 289, 251, 982, 322, 874, 656, 944, 973, 904, 734, 507, 789, 274, 837, 461, 208, 219, 233, 986]
      // data: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38']
      // data: [{x:1,y:157},{x:2,y:973},{x:3,y:248},{x:4,y:827},{x:5,y:577},{x:6,y:926},{x:7,y:884},{x:8,y:854},{x:9,y:658},{x:10,y:407},{x:11,y:746},{x:12,y:198},{x:13,y:804},{x:14,y:426},{x:15,y:115},{x:16,y:217},{x:17,y:185},{x:18,y:902},{x:19,y:715},{x:20,y:289},{x:21,y:251},{x:22,y:982},{x:23,y:322},{x:24,y:874},{x:25,y:656},{x:26,y:944},{x:27,y:973},{x:28,y:904},{x:29,y:734},{x:30,y:507},{x:31,y:789},{x:32,y:274},{x:33,y:837},{x:34,y:461},{x:35,y:208},{x:36,y:219},{x:37,y:233},{x:38,y:986}]
    }],
    chartOptions: {
      colors: themeColors,
      // colors: ['#ff9e43', '#03a9f4', '#01e396'],
      chart: {
        stacked: false,
        animations: {
          initialAnimation: {
            enabled: false
          }
        }
      },
      stroke: {
        width: [0, 1, 1],
        curve: 'smooth'
      },
      plotOptions: {
        bar: {
          columnWidth: '25%'
        }
      },

      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100]
        }
      },
      // labels: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'
      // ],
      markers: {
        size: [0, 0, 3]
      },
      xaxis: {
        // categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38']
      },
      yaxis: [{
        title: {
          text: 'Stock ( units )',
        },
        min: 0
      }, {
        title: {
          text: "Rate of Sale per Week ( Units )"
        },
        opposite: true,
      }],
      tooltip: {
        //   custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        //     let label = ['UnderStock', 'Optimum Stock', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'UnderStock', 'underStock', 'Over Stock', 'underStock', 'underStock', 'underStock', 'OOS', 'Over Stock', 'OOS', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'UnderStock', 'underStock', 'Over Stock', 'underStock', 'underStock', 'underStock', 'OOS'];
        //     return (
        //         '<div class="custom-tooltip">' +
        //         '<div class="group">' +
        //         '<div>Stock Assortment</div>' +
        //         '<div class="group1">Rate of Sale: ' +
        //         series[0][dataPointIndex] +
        //         '</div>' +
        //         '<div class="group2">Stock In Hand: ' +
        //         series[1][dataPointIndex] +
        //         '</div>' +
        //         '</div>' +
        //         '<div class="group">' +
        //         '<div class="hilite"><span class="lite">' +
        //         label[dataPointIndex]+
        //         // tooltipInfo(data[0].itemSold[dataPointIndex], 'Items') +
        //         '</span> <br />' +
        //         // tooltipInfo(data[0].saleReason[dataPointIndex], 'Reason') +
        //         '</div>' +
        //         '</div>' +
        //         '</div>'
        //     );
        // },
        // shared: true,
        // intersect: false,
        // y: {
        //     formatter: function(y) {
        //         if (typeof y !== "undefined") {
        //             return y.toFixed(0) +' units';
        //         }
        //         return y;

        //     }
        // },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {

          function colorCode(type) {
            if (type === 'OOS') {
              return "color:red; font-size:30px";
            } else if (type === 'Under Stock') {
              return "color:orange;";
            } else if (type === 'Over Stock') {
              return "color:orange; font-size:30px";
            } else {
              return "color:green";
            }
          }

          return (
            '<div class="custom-tooltip">' +
            '<div class="group">' +
            '<div><span>' + w.config.series[0].categories[dataPointIndex] + '</span> <br />' +
            '</div>' +
            '<div class="group1">Expected Sale per Week: ' +
            '<strong>' + series[0][dataPointIndex] + '</strong>' +
            '</div>' +
            '<div class="group1">Stock In Hand: ' +
            '<strong>' + series[1][dataPointIndex] + '</strong>' +
            '</div>' +
            '</div>' +
            '<div class="group">' +
            '<h5 style="' + colorCode(w.config.series[2].categories[dataPointIndex]) + '">' + w.config.series[2].categories[dataPointIndex] + '</h5>' +
            '</div>' +
            '</div>' +
            '</div>'
          );
        }
      }
    }
  },
  scatterChartDemo: {
    series: [{
      name: "Inventory Analysis",
      categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
      data: [
        [157,573],
        [973,490],
        [248,551],
        [827,495],
        [577,781],
        [926,385],
        [884,591],
        [854,862],
        [658,305],
        [407,129],
        [746,572],
        [198,708],
        [804,543],
        [426,146],
        [115,928],
        [217,905],
        [185,972],
        [902,958],
        [715,285],
        [289,234],
        [251,631],
        [982,534],
        [322,640],
        [874,568],
        [656,843],
        [944,453],
        [973,638],
        [904,921],
        [734,342],
        [507,137],
        [789,653],
        [274,776],
        [837,605],
        [461,204],
        [208,1005],
        [219,986],
        [233,981],
        [986,1019]
      ]
    }],
    chartOptions: {
      colors: themeColors,
      annotations: {
        position: 'front',
        yaxis: [
          {
            y: 600,
            borderColor: "#2698FF",
            label: {
              borderColor: "#2698FF",
              style: {
                color: "#fff",
                background: "#2698FF"
              },
              text: "Inventory"
            }
          }
      ],
      xaxis: [
        {
          // in a datetime series, the x value should be a timestamp, just like it is generated below
          x: 500,
          strokeDashArray: 0,
          borderColor: "#2698FF",
          label: {
            borderColor: "#2698FF",
            style: {
              color: "#fff",
              background: "#2698FF"
            },
            text: "Rate of Sale"
          }
        }
      ],
      points: [
        {
          x: 745,
          y: 1000,
          marker: {
            size: 10,
            fillColor: "#00E396",
            strokeColor: "#00E396",
            radius: 10
          },
          label: {
            borderColor: "#00E396",
            offsetY: 0,
            style: {
              color: "#fff",
              background: "#00E396"
            },
  
            text: "Optimal Stock"
          }
        }, {
          x: 255,
          y: 1000,
          marker: {
            size: 5,
            fillColor: "#FF4560",
            strokeColor: "#FF4560",
            radius: 10
          },
          label: {
            borderColor: "#FF4560",
            offsetY: 0,
            style: {
              color: "#fff",
              background: "#FF4560"
            },
  
            text: "Under Stock"
          }
        }, {
          x: 255,
          y: 150,
          marker: {
            size: 3,
            fillColor: "#FF4560",
            strokeColor: "#FF4560",
            radius: 10
          },
          label: {
            borderColor: "#FF4560",
            offsetY: 0,
            style: {
              color: "#fff",
              background: "#FF4560"
            },
  
            text: "Idle Stock"
          }
        }, {
          x: 745,
          y: 150,
          marker: {
            size: 20,
            fillColor: "#FF4560",
            strokeColor: "#FF4560",
            radius: 10
          },
          label: {
            borderColor: "#FF4560",
            offsetY: 0,
            style: {
              color: "#fff",
              background: "#FF4560"
            },
  
            text: "Over Stock"
          }
        }
      ]
      },
      chart: {
        zoom: {
          enabled: true,
          type: 'xy'
        },
        toolbar: {
          show: true,
          autoSelected: 'zoom'
      }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'solid',
      },
      markers: {
        size: [10]
      },
      grid: {
        show: false
      },
      xaxis: {
        // offsetY: -200,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
          color: '#008FFB'
        },
        labels: {
          show: false,
          style: {
            color: '#008FFB',
          }
        },
        title: {
          show: false,
          // text: "Inventory",
          style: {
            color: '#008FFB',
          }
        },
        tooltip: {
          enabled: true
        },
        tickAmount: 8,
      },
      yaxis: {
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
          color: '#008FFB'
        },
        labels: {
          show:false,
          style: {
            color: '#008FFB',
          }
        },
        title: {
          show: false,
          // text: "Rate of Sale / Week",
          style: {
            color: '#008FFB',
          }
        },
        tooltip: {
          enabled: true
        }
      }
    }
  }

}
